import PropTypes from 'prop-types';
import styles from './FJTextToImageRight.module.less';
import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJCreationPanelContainer from '../../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import FJImageToVideoButtonContainer from '../../../../common/combineComponents/FJImageToVideoButtonContainer/container/FJImageToVideoButtonContainer.jsx';
import FJMultiSourceDownloadButtonContainer from '../../../../common/combineComponents/FJMultiSourceDownloadButton/FJMultiSourceDownloadButtonContainer.jsx';
import FJConstant from '../../../../constants/FJConstant';
import FJAppConstant from '../../../../constants/FJAppConstant.js';

const FJTextToImageRight = props => {
    const { isShowPresetImageBox, onRetry } = props;

    const renderRightChildren = () => {
        if (window.isEditPage) return null; // 使用内部的download组件
        return (
            <div className={styles.right_children_box}>
                <FJImageToVideoButtonContainer isOnlyBtn={true} />
                <FJMultiSourceDownloadButtonContainer />
            </div>
        );
    };

    return (
        <div className={styles.app_right}>
            <FJDisplayHeaderContainer hideCancelButton={true} rightChildren={renderRightChildren()} />

            <FJCreationPanelContainer
                activeHeaderTabIndex={FJConstant.CREATIONS}
                hideCompare={true}
                onRetry={onRetry}
                isShowPresetImageBox={isShowPresetImageBox}
                appType={FJAppConstant.TEXT_TO_IMAGE}
            />

            <FJHistoryPanelContainer activeHeaderTabIndex={FJConstant.HISTORY} />
        </div>
    );
};

FJTextToImageRight.propTypes = {
    isShowPresetImageBox: PropTypes.bool,
    onRetry: PropTypes.func,
};

export default FJTextToImageRight;
